export default __webpack_public_path__ + "static/HandAndStoneAlt-0e923a67c1e37ae9045beb5b864770a9.png";